module.exports = __webpack_public_path__ + "static/img/PC-2.7778afc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/PC-2.png
// module id = DpQY
// module chunks = 0